import React, { useState } from 'react'
import { connect } from 'react-redux'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import { addRecord, updateRecord } from 'app/gears/nadl/actions/nadlActions'


let NADLRecordForm = ({ adding, focusing, canEditRecords, canEditDocuments, handleReset, recordToFocus, posting, success, error, addRecord, updateRecord }) => {
  const [dateErrors, setDateErrors] = useState([])
  const dateRegex = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/
  const validateDate = (e) =>
    e.target.value.length > 0 && !dateRegex.test(e.target.value) ?
      setDateErrors([...dateErrors].includes(e.target.name) ? [...dateErrors] : [...dateErrors, e.target.name])
      : setDateErrors(dateErrors.filter(error => error !== e.target.name))


  const handleSubmit = (e) => {
    e.preventDefault();
    let record = {}
    Array.from(e.target).forEach(field => {
      record[field.name] = field.value;
    })
    if (adding) {
      addRecord(record)
    } else {
      updateRecord(recordToFocus.id, record)
    }
    handleReset();
  }
  return (
    <div>
      {adding &&
        <>
          <h3>Add New Record</h3>
          <p>Please fill out the form below and click <b>Submit</b> to add a new record.</p>
        </>}
      {focusing &&
        <>
          <h3>View{canEditRecords && '/Edit'} Record</h3>
          {canEditRecords && <p>You can edit this record by changing the appropriate fields and clicking <b>Submit</b>.</p>}
          {!canEditRecords && <p>Note that the following record is <i>read-only</i> based on your current permissions.</p>}
        </>}
      {dateErrors.length > 0 && <LgyAlertDialog type='error' heading='Invalid Date' text={`One or more of the dates you entered is not of format: MM/DD/YYYY. You must correct these before you can submit.`} />}
      <button onClick={() => handleReset()}>Return to List of Records</button>
      <form onSubmit={handleSubmit} autoComplete='off'>

        <BasicLgyInputField
          name='dateCommitmentIssued'
          label='Date Commitment Issued'
          placeholder='MM/DD/YYYY'
          defaultValue={focusing ? recordToFocus.dateCommitmentIssued : ''}
          maxLength='10'
          disabled={!canEditRecords}
          onChange={e => validateDate(e)}
          required />
        <BasicLgyInputField name='lin' label='LIN' placeholder='XX-XX-X-XXXXXXX' defaultValue={focusing ? recordToFocus.lin : ''} maxLength='15' disabled={!canEditRecords} required />
        <BasicLgyInputField name='mouNo' label='MOU No' defaultValue={focusing ? recordToFocus.mouNo : ''} maxLength='20' disabled={!canEditRecords} required />
        <BasicLgyInputField name='firstName' label='First Name' defaultValue={focusing ? recordToFocus.firstName : ''} maxLength='50' disabled={!canEditRecords} required />
        <BasicLgyInputField name='mi' label='Middle Initial' defaultValue={focusing ? recordToFocus.mi : ''} maxLength='1' disabled={!canEditRecords} />
        <BasicLgyInputField name='lastName' label='Last Name' defaultValue={focusing ? recordToFocus.lastName : ''} maxLength='50' disabled={!canEditRecords} required />
        <BasicLgyInputField name='loanCommitmentAmount' label='Loan Commitment Amount' defaultValue={focusing ? recordToFocus.loanCommitmentAmount : ''} maxLength='20' disabled={!canEditRecords} required />
        <BasicLgySelectField name='stageDispursements' label='Stage Dispursements?' defaultValue={focusing ? recordToFocus.stageDispursements : ''} disabled={!canEditRecords}>
          <option value='Yes'>Yes</option>
          <option value='No'>No</option>
        </BasicLgySelectField>

        <BasicLgyInputField name='dispursementDate1' placeholder='MM/DD/YYYY' defaultValue={focusing ? recordToFocus.dispursementDate1 : ''} label='Dispursement Date 1' maxLength='10'
          disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='dispursementAmount1' defaultValue={focusing ? recordToFocus.dispursementAmount1 : ''} label='Dispursement Amount 1' maxLength='20' disabled={!canEditRecords} />
        <BasicLgyInputField name='comment1' defaultValue={focusing ? recordToFocus.comment1 : ''} label='Comment 1' maxLength='50' disabled={!canEditRecords} />

        <BasicLgyInputField name='dispursementDate2' placeholder='MM/DD/YYYY' defaultValue={focusing ? recordToFocus.dispursementDate2 : ''} label='Dispursement Date 2' maxLength='10'
          disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='dispursementAmount2' defaultValue={focusing ? recordToFocus.dispursementAmount2 : ''} label='Dispursement Amount 2' maxLength='20' disabled={!canEditRecords} />
        <BasicLgyInputField name='comment2' defaultValue={focusing ? recordToFocus.comment2 : ''} label='Comment 2' maxLength='50' disabled={!canEditRecords} />

        <BasicLgyInputField name='dispursementDate3' placeholder='MM/DD/YYYY' defaultValue={focusing ? recordToFocus.dispursementDate3 : ''} label='Dispursement Date 3' maxLength='10'
          disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='dispursementAmount3' defaultValue={focusing ? recordToFocus.dispursementAmount3 : ''} label='Dispursement Amount 3' maxLength='20' disabled={!canEditRecords} />
        <BasicLgyInputField name='comment3' defaultValue={focusing ? recordToFocus.comment3 : ''} label='Comment 3' maxLength='50' disabled={!canEditRecords} />

        <BasicLgyInputField name='dispursementDate4' placeholder='MM/DD/YYYY' defaultValue={focusing ? recordToFocus.dispursementDate4 : ''} label='Dispursement Date 4' maxLength='10'
          disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='dispursementAmount4' defaultValue={focusing ? recordToFocus.dispursementAmount4 : ''} label='Dispursement Amount 4' maxLength='20' disabled={!canEditRecords} />
        <BasicLgyInputField name='comment4' defaultValue={focusing ? recordToFocus.comment4 : ''} label='Comment 4' maxLength='50' disabled={!canEditRecords} />

        <BasicLgyInputField name='dispursementDate5' placeholder='MM/DD/YYYY' defaultValue={focusing ? recordToFocus.dispursementDate5 : ''} label='Dispursement Date 5' maxLength='10'
          disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='dispursementAmount5' defaultValue={focusing ? recordToFocus.dispursementAmount5 : ''} label='Dispursement Amount 5' maxLength='20' disabled={!canEditRecords} />
        <BasicLgyInputField name='comment5' defaultValue={focusing ? recordToFocus.comment5 : ''} label='Comment 5' maxLength='50' disabled={!canEditRecords} />

        <BasicLgyInputField name='dateLoanClosed' defaultValue={focusing ? recordToFocus.dateLoanClosed : ''}
          placeholder='MM/DD/YYYY' maxLength='10' label='Date Loan Closed' disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='finalLoanAmount' defaultValue={focusing ? recordToFocus.finalLoanAmount : ''} label='Final Loan Amount' maxLength='20' disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='dateReportPLOU' defaultValue={focusing ? recordToFocus.dateReportPLOU : ''}
          placeholder='MM/DD/YYYY' label='Date Report PLOU' disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='servicerReportDate' defaultValue={focusing ? recordToFocus.servicerReportDate : ''}
          placeholder='MM/DD/YYYY' maxLength='10' label='Servicer Report Date' disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='alacReceiptDate' defaultValue={focusing ? recordToFocus.alacReceiptDate : ''}
          placeholder='MM/DD/YYYY' maxLength='10' label='ALAC Receipt Date' disabled={!canEditRecords} onChange={e => validateDate(e)} />
        <BasicLgyInputField name='paidInFullDate' defaultValue={focusing ? recordToFocus.paidInFullDate : ''}
          placeholder='MM/DD/YYYY' maxLength='10' label='Paid In Full Date' disabled={!canEditRecords} onChange={e => validateDate(e)} />
        {dateErrors.length > 0 && <LgyAlertDialog type='error' heading='Invalid Date' text={`One or more of the dates you entered is not of format: MM/DD/YYYY. You must correct these before you can submit.`} />}
        {canEditRecords &&
          dateErrors.length < 1 &&
          <LgyFormSubmit
            submitting={posting}
            submitSucceeded={success}
            submitFailed={error} />}
      </form>
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.nadlRecords
})
const mapDispatchToProps = { addRecord, updateRecord }

NADLRecordForm = connect(mapStateToProps, mapDispatchToProps)(NADLRecordForm)

export default NADLRecordForm